import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import "react-datepicker/dist/react-datepicker.css";
import { changeDateFormat} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {agriculturePartyIndexReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function AgriculturalParityIndex() {
        // const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    // const decode_token = jwtDecode(token);
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [yearType, setYearType] = useState("");
    const storedLanguage = localStorage.getItem('language');
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();


    useEffect(() => { //Get all Years Data
        //Years
       const fetchYears = async () => {
          showLoading(true)
    
          const currentYear = new Date().getFullYear();
          const endYear = 2001;
          const yearsArray = [];
    
          for (let year = currentYear; year >= endYear; year--) {
            yearsArray.push(`${year}-${year + 1}`);
          }
    
          setYears(yearsArray);
          showLoading(false);
        };
    
      fetchYears();
    }, []);
    
 

// Handle on change Event ********
const handleDropdownChange = (e) => {

    switch (e.target.name) {
        case "yearName":
        setYearName(e.target.value);
        break;
        case "yearType":
        setYearType(e.target.value);
        break;
    default:
        console.log("switch case are not match");
        break;
    }
    };

    

// Function to generate Excel file using mapped data
const handleGenerateExcel = async () => {

    if (!yearType) {
        toast.error("Please select Year Type", messages.COLOR_RED);
        return;
    }
    if (!yearName) {
        toast.error("Please select Year", messages.COLOR_RED);
        return;
    }
   


try{

      let postData = {
        reportType: yearType,
        surveyYear:yearName
        }
    showLoading(true);
    const response = await axios.post(`${API_URL}api/price/PriAgriculturalParityIndex`, postData, config);
    const allData = response.data;

        if(allData.status){
            downloadReport(allData.data.GroupCodes,allData.data.payload,yearName,yearType)
        }else{
           toast.error(`Data is not found`, messages.COLOR_RED);
        }

    } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
        showLoading(false);
    }

}


// handle Download All report Data ****************
const downloadReport=(allData,payload,yearName,yearType)=>{
    let col2 = payload.grandTotalofcol2
    let col15 = payload.grandTotalofcol15
    let col16 = payload.grandTotalofcol16
    let col17 = payload.grandTotalofcol17
    let col18 = payload.grandTotalofcol18

let reportData=allData.map(item => [
    item.col1,
    item.col2,
    item.col15,
    item.col16,
    item.col17,
    item.col18,

    ]);
 
 reportData[reportData.length]=['TOTAL',col2,col15,col16,
        col17,col18]
let reportStructure = {
            year:yearName,
            fileName:`PriAgricultureParityIndex${yearName.split('-')[0]}`,
            fileType:'xls',
            sheetName: 'pri_lws_wages_unskilled',
            firstRowMergeCells: "A1:F1",
            firstRowExportDate:  changeDateFormat(new Date()),
            secondRowMergeCells: "A2:F2",
            secondRowText:'कृषीय क्रय-विक्रय समता सूचकांक, उत्तर प्रदेश ',  
            thirdRowMergeCells: "A3:F3" , 
            thirdRowText:'AGRICULTURAL PARITY INDEX, U.P.',    
            fourthRowText:[`कृषि वर्ष- ${yearName}`,'','',`Agrl. Year: ${yearName}`,'',''], 
            fifthRowMergeCells: "A5:F5",
            fifthRowText:'(क)कृषकों द्वारा प्राप्त भाव सूचकांक (आधार वर्ष 2011-12=100)',
            sixthRowMergeCells: "A6:F6",
            sixthRowText:'(a)Index of prices received by the farmers (Base Year 2011-12=100)',                                                                                            
            headerHindiColumns: ['मद / फसल ','प्रतिशत',' कृषि वर्ष',' कृषि वर्ष',' कृषि वर्ष','कृषि वर्ष' ],
            headerYearColumns: ['','',payload.year3Range,
                payload.year2Range,payload.year1Range,payload.yearRange],
            headerNumberColumns: [1,2,3,4,5,6],
            excelRowData:reportData
   }
  agriculturePartyIndexReport(reportStructure)
}
    
    


  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.AGRICULTURE_PARTY_REPORT : priceTitle.en.AGRICULTURE_PARTY_REPORT }} />
              
                    </h4>
                    <div className="row align-items-center">
                        

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6"> Select Year Type	</label>
                            <select
                            name="yearType"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={yearType}
                            >
                            <option value="" disabled>Select Month</option>
                            <option  value="a">  Agriculture Year </option>
                         </select>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6"> Select Year</label>
                            <select
                            name="yearName"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={yearName}
                            >
                            <option value="" disabled >Select Year</option>
                            {years.map((ele, index) => (
                                <option key={index} value={ele}>
                                {ele}
                                </option>
                            ))}
                         </select>
                        </div>



                        <div className="col-xl-2 col-lg-4 mb-3">
                            <label className="w-100 d-none d-sm-block">&nbsp;</label>
                            <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default AgriculturalParityIndex